const create = {
  en: {
    "login.button.title": "Log In",
    "settings.lang.en": "English",
    "settings.lang.es": "Spanish",
    "settings.lang.uk": "Ukrainian",

    "common.trading": "Trading",
    "common.finance": "Finance",
    "common.support": "Support",
    "common.markets": "Markets",
    "common.market": "Market",
    "common.copytrade": "Copy Trading",
    "common.wallet": "Wallet",
    "common.profile": "Profile",
    "common.my_profile": "My Profile",
    "common.coming-soon": "Coming Soon...",
    "common.history": "History",
    "common.security": "Security",
    "common.theme": "Theme",
    "common.logout": "Log Out",
    "common.app_for_ios": "App for iOS",
    "common.desktop_version": "Desktop version",
    "common.trade": "Trade",
    "common.futures": "Futures",
    "common.real": "Safe",
    "common.demo": "Demo account",
    "common.demo_futures": "Demo account",
    "common.real_futures": "Real account",

    "common.deposit": "Deposit",
    "common.deposit_header_btn": "TOP UP",
    "common.deposit2": "Deposit",
    "common.withdrawal": "Withdrawal",
    "common.trading_pairs": "Trading pairs",
    "common.forex": "Forex",
    "common.crypto": "Crypto",
    "common.fiat": "Fiat",
    "common.date": "Date",
    "common.payment_method": "Payment method",
    "common.method": "Method",
    "common.payee_wallet": "Wallet",
    "common.amount": "Amount",
    "common.status": "Status",
    "common.network": "Network",
    "common.commission": "Commission",
    "common.type": "Type",
    "common.balance": "Balance",

    "common.not_found": "Not found",
    "common.all": "All",
    "common.verified": "Verified",
    "common.pending": "Pending",
    "common.unverified": "Unverified",
    "common.rejected": "Rejected",

    "common.cryptocurrency": "Cryptocurrency",
    "common.enter_amount": "Enter Amount",
    "common.enter_password": "Enter password",
    "common.password": "Password",
    "common.email": "Email",
    "common.enter_email": "Email",
    "common.enter_code": "Enter code",
    "common.search": "Search",
    "common.next": "Next",
    "futures.previous": "Previous",

    "common.theme_type": "Theme type",
    "common.green": "Green",
    "common.blue": "Blue",
    "common.orange": "Orange",
    "common.red": "Red",
    "common.white": "White",
    "common.dark_green": "Dark green",
    "common.dark": "Dark",
    "common.light": "Light",

    "common.back_to_login": "Back to Login",

    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.confirm": "Confirm",
    "common.export": "Export",
    "common.successful": "Successful",
    "common.failed": "Failed",
    "common.warning": "Let’s get real",

    "common.banned": "You are banned!",
    "common.delete": "Delete",
    "common.upload": "Upload",
    "common.company": "Company",
    "common.about_us": "About Us",
    "common.benefit": "Benefit",
    "common.contact_us": "Contact Us",
    "common.loading": "Loading...",
    "common.change": "Change",
    "common.manage": "Manage",
    "common.add": "Add",
    "common.view_details": "View details",
    "common.copy": "Copy",
    "common.copied": "Copied!",
    "common.no_data": "No data",
    "common.get_verified": "Get verified",
    "error.invalid_file_type_detailed":
      "Invalid file format. Please use: PNG, JPG, GIF, or WebP.",

    "common.asset_selection": "Asset selection",
    "common.search_crypto": "Search crypto",

    "trading.real_account_title": "You Are Trading On Real Account",
    "trading.real_account_today_stats": "Real account statistics for today:",
    "trading.demo_account_today_stats": "Demo account statistics for today:",
    "trading.real_account_trades": "Trades:",
    "trading.real_account_turnover": "Trading turnover:",
    "trading.real_account_profit": "Trading profit:",
    "trading.real_account_overall_stats": "Real Account Overall Statistics",
    "trading.demo_account_title": "You Are Trading On Demo Account",
    "trading.demo_account_overall_stats": "Demo Account Overall Statistics",

    "common.months.january": "January",
    "common.months.february": "February",
    "common.months.march": "March",
    "common.months.april": "April",
    "common.months.may": "May",
    "common.months.june": "June",
    "common.months.july": "July",
    "common.months.august": "August",
    "common.months.september": "September",
    "common.months.october": "October",
    "common.months.november": "November",
    "common.months.december": "December",

    "common.weekdays.sunday": "Sun",
    "common.weekdays.monday": "Mon",
    "common.weekdays.tuesday": "Tue",
    "common.weekdays.wednesday": "Wed",
    "common.weekdays.thursday": "Thu",
    "common.weekdays.friday": "Fri",
    "common.weekdays.saturday": "Sat",

    "common.hours.short": "h",

    "common.today": "Today",
    "common.yesterday": "Yesterday",
    "common.last_7_days": "Last 7 days",
    "common.last_30_days": "Last 30 days",
    "common.current_month": "Current month",
    "common.previous_month": "Previous month",
    "common.all_time": "All time",
    "common.custom_range": "Custom range",
  },
  ru: {
    "login.button.title": "Войти",
    "settings.lang.en": "English",
    "settings.lang.es": "Spanish",
    "settings.lang.uk": "Ukrainian",

    "common.trading": "Торговля",
    "common.finance": "Финансы",
    "common.support": "Поддержка",
    "common.markets": "Рынки",
    "common.market": "Рынок",
    "common.copytrade": "Копитрейдинг",
    "common.wallet": "Кошелек",
    "common.profile": "Профиль",
    "common.my_profile": "Мой профиль",
    "common.coming-soon": "Скоро будет...",
    "common.history": "История",
    "common.security": "Безопасность",
    "common.theme": "Темы",
    "common.logout": "Выйти",
    "common.app_for_ios": "Приложение для iOS",
    "common.desktop_version": "Версия для ПК",
    "common.trade": "Торговля",
    "common.futures": "Фьючерсы",
    "common.real": "Сей",
    "common.demo": "Демо счет",
    "common.demo_futures": "Демо-счет",
    "common.real_futures": "Реальный счет",

    "common.deposit": "Пополнить баланс",
    "common.deposit_header_btn": "ПОПОЛНИТЬ СЧЕТ",
    "common.deposit2": "Пополнить",
    "common.withdrawal": "Вывод средств",
    "common.trading_pairs": "Торговые инструменты",
    "common.forex": "Forex",
    "common.crypto": "Криптовалюта",
    "common.fiat": "Fiat",
    "common.date": "Дата",
    "common.payment_method": "Платежный шлюз",
    "common.method": "Способ",
    "common.payee_wallet": "Кошелек",
    "common.amount": "Сумма",
    "common.status": "Статус",
    "common.network": "Сеть",
    "common.commission": "Комиссия",
    "common.type": "Тип",
    "common.balance": "Баланс",

    "common.not_found": "Не найдено",
    "common.all": "Все",
    "common.verified": "Верифицированы",
    "common.pending": "В ожидании",
    "common.unverified": "Неверифицированный",
    "common.rejected": "Отклоненный",

    "common.cryptocurrency": "Криптовалюта",
    "common.enter_amount": "Введите сумму",
    "common.enter_password": "Введите пароль",
    "common.password": "Пароль",
    "common.email": "E-mail",
    "common.enter_email": "E-mail",
    "common.enter_code": "Введите 2FA код",
    "common.search": "Поиск",
    "common.next": "Далее",
    "futures.previous": "Предыдущий",

    "common.theme_type": "Тема",
    "common.green": "Green",
    "common.blue": "Blue",
    "common.orange": "Orange",
    "common.red": "Red",
    "common.white": "White",
    "common.dark_green": "Dark green",
    "common.dark": "Темная",
    "common.light": "Светлая",

    "common.cancel": "Отмена",
    "common.save": "Сохранить",
    "common.confirm": "Подтвердить",
    "common.export": "Экспорт",
    "common.successful": "Успешно",
    "common.failed": "Неудача",
    "common.warning": "Предупреждение",

    "common.back_to_login": "Вернуться на страницу авторизации",

    "common.banned": "Вы заблокированы!",
    "common.delete": "Удалить",
    "common.upload": "Загрузить",
    "common.company": "Компания",
    "common.about_us": "О нас",
    "common.benefit": "Преимущества",
    "common.contact_us": "Связаться с нами",
    "common.loading": "Загрузка...",
    "common.change": "Изменить",
    "common.manage": "Управлять",
    "common.add": "Добавить",
    "common.view_details": "Посмотреть детали",
    "common.copy": "Копировать",
    "common.copied": "Скопировано!",
    "common.no_data": "Нет данных",
    "common.get_verified": "Пройти верификацию",
    "error.invalid_file_type_detailed":
      "Недопустимый формат файла. Пожалуйста, используйте: PNG, JPG, GIF или WebP.",

    "common.asset_selection": "Выбор актива",
    "common.search_crypto": "Поиск криптовалюты",

    "trading.real_account_title": "Вы торгуете на реальном счете",
    "trading.real_account_today_stats":
      "Статистика реального счета за сегодня:",
    "trading.demo_account_today_stats": "Статистика демо-счета за сегодня:",
    "trading.real_account_trades": "Сделки:",
    "trading.real_account_turnover": "Торговый оборот:",
    "trading.real_account_profit": "Торговая прибыль:",
    "trading.real_account_overall_stats": "Общая статистика реального счета",
    "trading.demo_account_title": "Вы торгуете на демо-счете",
    "trading.demo_account_overall_stats": "Общая статистика демо-счета",

    "common.months.january": "Январь",
    "common.months.february": "Февраль",
    "common.months.march": "Март",
    "common.months.april": "Апрель",
    "common.months.may": "Май",
    "common.months.june": "Июнь",
    "common.months.july": "Июль",
    "common.months.august": "Август",
    "common.months.september": "Сентябрь",
    "common.months.october": "Октябрь",
    "common.months.november": "Ноябрь",
    "common.months.december": "Декабрь",

    "common.weekdays.sunday": "Вс",
    "common.weekdays.monday": "Пн",
    "common.weekdays.tuesday": "Вт",
    "common.weekdays.wednesday": "Ср",
    "common.weekdays.thursday": "Чт",
    "common.weekdays.friday": "Пт",
    "common.weekdays.saturday": "Сб",

    "common.hours.short": "ч",

    "common.today": "Сегодня",
    "common.yesterday": "Вчера",
    "common.last_7_days": "Последние 7 дней",
    "common.last_30_days": "Последние 30 дней",
    "common.current_month": "Текущий месяц",
    "common.previous_month": "Предыдущий месяц",
    "common.all_time": "За всё время",
    "common.custom_range": "Специальный диапазон",
  },

  es: {
    "login.button.title": "Iniciar sesión",
    "settings.lang.en": "Inglés",
    "settings.lang.es": "Español",
    "settings.lang.uk": "Ucraniano",

    "common.trading": "Trading",
    "common.finance": "Finanzas",
    "common.support": "Soporte",
    "common.markets": "Mercados",
    "common.market": "Mercado",

    "common.copytrade": "Copy Trading",
    "common.wallet": "Cartera",
    "common.profile": "Perfil",
    "common.my_profile": "Mi Perfil",
    "common.coming-soon": "Próximamente...",
    "common.history": "Historial",
    "common.security": "Seguridad",
    "common.theme": "Tema",
    "common.logout": "Cerrar sesión",
    "common.app_for_ios": "App para iOS",
    "common.desktop_version": "Versión de escritorio",
    "common.trade": "Comerciar",
    "common.real": "Cuenta real",
    "common.demo": "Cuenta demo",
    "common.futures": "Futuros",
    "common.demo_futures": "Cuenta Demo",
    "common.real_futures": "Cuenta Real",

    "common.deposit": "Depósito",
    "common.deposit_header_btn": "DEPOSITAR FONDOS",
    "common.withdrawal": "Retiro",
    "common.deposit2": "Depósito",
    "common.trading_pairs": "Pares de trading",
    "common.forex": "Forex",
    "common.crypto": "Criptomonedas",
    "common.fiat": "Fiat",
    "common.date": "Fecha",
    "common.payment_method": "Método de pago",
    "common.method": "Método",
    "common.payee_wallet": "Cartera",
    "common.amount": "Cantidad",
    "common.status": "Estado",
    "common.network": "Red",
    "common.commission": "Comisión",
    "common.type": "Tipo",
    "common.balance": "Balance",

    "common.not_found": "No encontrado",
    "common.all": "Todos",
    "common.verified": "Verificado",
    "common.pending": "Pendiente",
    "common.unverified": "No verificado",
    "common.rejected": "Rechazado",

    "common.cryptocurrency": "Criptomoneda",
    "common.enter_amount": "Introducir cantidad",
    "common.enter_password": "Introducir contraseña",
    "common.password": "Contraseña",
    "common.email": "Correo electrónico",
    "common.enter_email": "Correo electrónico",
    "common.enter_code": "Introducir código",
    "common.search": "Buscar",
    "common.next": "Siguiente",

    "common.theme_type": "Tipo de tema",
    "common.green": "Verde",
    "common.blue": "Azul",
    "common.orange": "Naranja",
    "common.red": "Rojo",
    "common.white": "Blanco",
    "common.dark_green": "Verde oscuro",
    "common.dark": "Dark",
    "common.light": "Light",
    "futures.previous": "Anterior",

    "common.back_to_login": "Volver al inicio de sesión",

    "common.cancel": "Cancelar",
    "common.save": "Guardar",
    "common.confirm": "Confirmar",
    "common.export": "Exportar",
    "common.successful": "Exitoso",
    "common.failed": "Fallido",
    "common.warning": "Nos vamos a real",

    "common.banned": "¡Estás baneado!",
    "common.delete": "Eliminar",
    "common.upload": "Subir",
    "common.company": "Empresa",
    "common.about_us": "Sobre nosotros",
    "common.benefit": "Beneficios",
    "common.contact_us": "Contáctanos",
    "common.loading": "Cargando...",
    "common.change": "Cambiar",
    "common.manage": "Gestionar",
    "common.add": "Añadir",
    "common.view_details": "Ver detalles",
    "common.copy": "Copiar",
    "common.copied": "¡Copiado!",
    "common.no_data": "Sin datos",
    "common.get_verified": "Verificar",
    "error.invalid_file_type_detailed":
      "Formato de archivo no válido. Por favor, use: PNG, JPG, GIF o WebP.",

    "common.asset_selection": "Selección de activos",
    "common.search_crypto": "Buscar criptomoneda",

    "trading.real_account_title": "Está operando en una cuenta real",
    "trading.real_account_today_stats":
      "Estadísticas de la cuenta real de hoy:",
    "trading.demo_account_today_stats":
      "Estadísticas de la cuenta demo de hoy:",
    "trading.real_account_trades": "Operaciones:",
    "trading.real_account_turnover": "Volumen de operaciones:",
    "trading.real_account_profit": "Beneficio comercial:",
    "trading.real_account_overall_stats":
      "Estadísticas generales de la cuenta real",
    "trading.demo_account_title": "Está operando en una cuenta demo",
    "trading.demo_account_overall_stats":
      "Estadísticas generales de la cuenta demo",

    "common.months.january": "Enero",
    "common.months.february": "Febrero",
    "common.months.march": "Marzo",
    "common.months.april": "Abril",
    "common.months.may": "Mayo",
    "common.months.june": "Junio",
    "common.months.july": "Julio",
    "common.months.august": "Agosto",
    "common.months.september": "Septiembre",
    "common.months.october": "Octubre",
    "common.months.november": "Noviembre",
    "common.months.december": "Diciembre",

    "common.weekdays.sunday": "Dom",
    "common.weekdays.monday": "Lun",
    "common.weekdays.tuesday": "Mar",
    "common.weekdays.wednesday": "Mié",
    "common.weekdays.thursday": "Jue",
    "common.weekdays.friday": "Vie",
    "common.weekdays.saturday": "Sáb",

    "common.hours.short": "h",

    "common.today": "Hoy",
    "common.yesterday": "Ayer",
    "common.last_7_days": "Últimos 7 días",
    "common.last_30_days": "Últimos 30 días",
    "common.current_month": "Mes actual",
    "common.previous_month": "Mes anterior",
    "common.all_time": "Todo el tiempo",
    "common.custom_range": "Rango especial",
  },

  ua: {
    "login.button.title": "Увійти",
    "settings.lang.en": "Англійська",
    "settings.lang.es": "Іспанська",
    "settings.lang.uk": "Українська",

    "common.trading": "Торгівля",
    "common.finance": "Фінанси",
    "common.support": "Підтримка",
    "common.markets": "Ринки",
    "common.market": "Ринок",
    "common.copytrade": "Копітрейдинг",
    "common.wallet": "Гаманець",
    "common.profile": "Профіль",
    "common.my_profile": "Мій профіль",
    "common.coming-soon": "Скоро буде...",
    "common.history": "Історія",
    "common.security": "Безпека",
    "common.theme": "Тема",
    "common.logout": "Вийти",
    "common.app_for_ios": "Додаток для iOS",
    "common.desktop_version": "Десктопна версія",
    "common.trade": "Торгувати",
    "common.futures": "Ф’ючерси",
    "common.real": "Безпечно",
    "common.demo": "Демо-рахунок",
    "common.demo_futures": "Демо-рахунок",
    "common.real_futures": "Реальний рахунок",

    "common.deposit": "Депозит",
    "common.deposit_header_btn": "ПОПОВНИТИ РАХУНОК",
    "common.deposit2": "Депозит",
    "common.withdrawal": "Виведення",
    "common.trading_pairs": "Торгові пари",
    "common.forex": "Форекс",
    "common.crypto": "Криптовалюта",
    "common.fiat": "Фіат",
    "common.date": "Дата",
    "common.payment_method": "Метод оплати",
    "common.method": "Спосіб",
    "common.amount": "Сума",
    "common.status": "Статус",
    "common.network": "Мережа",
    "common.commission": "Комісія",
    "common.type": "Тип",
    "common.balance": "Баланс",

    "common.not_found": "Не знайдено",
    "common.all": "Всі",
    "common.verified": "Підтверджено",
    "common.pending": "В очікуванні",
    "common.unverified": "Не підтверджено",
    "common.rejected": "Відхилено",

    "common.cryptocurrency": "Криптовалюта",
    "common.enter_amount": "Введіть суму",
    "common.enter_password": "Введіть пароль",
    "common.password": "Пароль",
    "common.email": "Електронна пошта",
    "common.enter_email": "Електронна пошта",
    "common.enter_code": "Введіть код",
    "common.search": "Пошук",
    "common.next": "Далі",
    "futures.previous": "Попередній",

    "common.theme_type": "Тип теми",
    "common.green": "Зелена",
    "common.blue": "Синя",
    "common.orange": "Помаранчева",
    "common.red": "Червона",
    "common.white": "Біла",
    "common.dark_green": "Темно-зелена",
    "common.dark": "Темна",
    "common.light": "Світла",

    "common.back_to_login": "Повернутися до входу",

    "common.cancel": "Скасувати",
    "common.save": "Зберегти",
    "common.confirm": "Підтвердити",
    "common.export": "Експорт",
    "common.successful": "Успішно",
    "common.failed": "Не вдалося",
    "common.warning": "Будьмо реалістами",

    "common.banned": "Вам заборонено!",
    "common.delete": "Видалити",
    "common.upload": "Завантажити",
    "common.company": "Компанія",
    "common.about_us": "Про нас",
    "common.benefit": "Переваги",
    "common.contact_us": "Звʼязатися з нами",
    "common.loading": "Завантаження...",
    "common.change": "Змінити",
    "common.manage": "Керувати",
    "common.add": "Додати",
    "common.view_details": "Переглянути деталі",
    "common.copy": "Копіювати",
    "common.copied": "Скопійовано!",
    "common.no_data": "Немає даних",
    "common.get_verified": "Пройти верифікацію",
    "error.invalid_file_type_detailed":
      "Неприпустимий формат файлу. Будь ласка, використовуйте: PNG, JPG, GIF, або WebP.",

    "common.asset_selection": "Вибір активу",
    "common.search_crypto": "Пошук криптовалюти",

    "trading.real_account_title": "Ви торгуєте на реальному рахунку",
    "trading.real_account_today_stats":
      "Статистика реального рахунку за сьогодні:",
    "trading.demo_account_today_stats": "Статистика демо-рахунку за сьогодні:",
    "trading.real_account_trades": "Угоди:",
    "trading.real_account_turnover": "Торговий оборот:",
    "trading.real_account_profit": "Торговий прибуток:",
    "trading.real_account_overall_stats":
      "Загальна статистика реального рахунку",
    "trading.demo_account_title": "Ви торгуєте на демо-рахунку",
    "trading.demo_account_overall_stats": "Загальна статистика демо-рахунку",

    "common.months.january": "Січень",
    "common.months.february": "Лютий",
    "common.months.march": "Березень",
    "common.months.april": "Квітень",
    "common.months.may": "Травень",
    "common.months.june": "Червень",
    "common.months.july": "Липень",
    "common.months.august": "Серпень",
    "common.months.september": "Вересень",
    "common.months.october": "Жовтень",
    "common.months.november": "Листопад",
    "common.months.december": "Грудень",

    "common.weekdays.sunday": "Нд",
    "common.weekdays.monday": "Пн",
    "common.weekdays.tuesday": "Вт",
    "common.weekdays.wednesday": "Ср",
    "common.weekdays.thursday": "Чт",
    "common.weekdays.friday": "Пт",
    "common.weekdays.saturday": "Сб",

    "common.hours.short": "г",

    "common.today": "Сьогодні",
    "common.yesterday": "Вчора",
    "common.last_7_days": "Останні 7 днів",
    "common.last_30_days": "Останні 30 днів",
    "common.current_month": "Поточний місяць",
    "common.previous_month": "Попередній місяць",
    "common.all_time": "За весь час",
    "common.custom_range": "Спеціальний діапазон",
  },
};

export default create;
